<div class="no-orders">
  <sd-icon [type]="iconTypes.BASKET"></sd-icon>
  <span>пока нет заказов</span>
  <a class="no-orders-btn" sdButton [routerLink]="['/catalog']" radius="l">не сдамся</a>
</div>
